module.exports = __webpack_public_path__ + "static/img/Ryder-Corrigan.a2c25f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ryder-Corrigan.jpg
// module id = c1Ke
// module chunks = 0